import { FuelType } from "@/interfaces";
import api from "@/lib/axios";
import { DefaultGetRequestParams, DefaultResponse } from "./types";

interface FuelTypeResponse extends DefaultResponse<FuelType, true> {}

export const fuelTypeService = {
  async index(params: DefaultGetRequestParams = { page: 1, per_page: 10 }) {
    const { page, per_page, search, filters } = params;
    const response = await api.get<FuelTypeResponse>("/fuel_type", {
      params: {
        page,
        per_page,
        search,
        ...filters,
      },
    });
    return response.data;
  },
};
